module.exports = __webpack_public_path__ + "img/manager.47927fc1.svg";